import React from 'react';

const ModernTable = ({ columns, data }) => {
  return (
    <div style={{ overflowX: 'auto', marginTop: '1rem' }}>
      <table className="modern-table" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
        <thead>
          <tr style={{ background: '#f4f6fa' }}>
            {columns.map((col, idx) => (
              <th
                key={col.key}
                style={{
                  padding: '12px',
                  fontWeight: 600,
                  borderBottom: '2px solid #eaeaea',
                  borderTopLeftRadius: idx === 0 ? '8px' : undefined,
                  borderTopRightRadius: idx === columns.length - 1 ? '8px' : undefined
                }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr><td colSpan={columns.length} style={{ textAlign: 'center', padding: '16px' }}>No data found</td></tr>
          ) : (
            data.map((row, idx) => (
              <tr
                key={idx}
                style={{ background: idx % 2 === 0 ? '#fff' : '#f9fbfc', transition: 'background 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.background = '#eaf4ff'}
                onMouseLeave={e => e.currentTarget.style.background = idx % 2 === 0 ? '#fff' : '#f9fbfc'}
              >
                {columns.map(col => (
                  <td
                    key={col.key}
                    style={{ padding: '10px', borderBottom: '1px solid #eaeaea' }}
                  >
                    {col.render ? col.render(row[col.key], row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ModernTable;
